import styled from '@emotion/styled';
import { themed, ITheme } from '../../../themer';

export const SelectCurrent = styled.div<{}, ITheme>`
	color: ${themed(({ select }) => select.current.color)};
`;
